import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { LocationDetail } from './locations/location-detail/location-detail';
import { DetailRequest } from './ticket/detail-request/detail-request';

export const routesAduanas: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'detail-request', component: DetailRequest, canActivate: [AuthGuard] },
  { path: 'detail-location', component: LocationDetail, canActivate: [AuthGuard] },

  { path: '**', redirectTo: 'home' },
];

export const routes = routesAduanas;
